import { render } from "./Congrats.vue?vue&type=template&id=6b4c9b97"
import script from "./Congrats.vue?vue&type=script&lang=js"
export * from "./Congrats.vue?vue&type=script&lang=js"

import exportComponent from "D:\\p2h_proj\\californiamilkprocessorboard\\markup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__